/**
 * §2.10 — Salesforce "Log a Call" blocks for the outreach basket.
 *
 * One note per VIN, which the attached `Salesforce_Note_Example.png` settles: the
 * record carries a single VIN field. The previous copy emitted one block for the
 * whole basket ("SIFT outreach — N VINs"), which had to be taken apart by hand.
 *
 * Still ONE copy action producing N blocks — the broker pastes them one at a
 * time, and clipboard round-trips per VIN would be worse than scrolling.
 */
import type { BasketVinGroup } from './basketGroups';

const SF_DATE = new Intl.DateTimeFormat('en-US', {
  month: '2-digit',
  day: '2-digit',
  year: 'numeric',
});

export const SALESFORCE_BLOCK_SEPARATOR = '--------------------';

/** `now` is injectable so the Due Date is assertable rather than whatever today is. */
export function toSalesforceBlocks(groups: BasketVinGroup[], now: Date = new Date()): string {
  const due = SF_DATE.format(now);
  return groups
    .map((g) => [
      'Subject: ManEx Consult',
      // Omitted rather than blank when the VIN was staged without seller context
      // (a manual assign from the pop-out does that).
      ...(g.seller ? [`Related To: ${g.seller}`] : []),
      'Status: Completed',
      'Call Category: BROKER',
      'Call Sub Type: Seller',
      'Type Of Call: Email',
      `VIN: ${g.vin}`,
      `Due Date: ${due}`,
      'Comments:',
      'Sent to potential buyers:',
      // Account numbers only — the example lists one buyer ID per line, and the
      // note is a record of who was contacted, not a contact sheet.
      ...g.buyers.map((b) => b.buyer_uid),
    ].join('\n'))
    .join(`\n\n${SALESFORCE_BLOCK_SEPARATOR}\n\n`);
}
